import { render, staticRenderFns } from "./BaseCardTotalizadorRastreabilidade.vue?vue&type=template&id=79710f90&scoped=true&lang=pug"
import script from "./BaseCardTotalizadorRastreabilidade.vue?vue&type=script&lang=js"
export * from "./BaseCardTotalizadorRastreabilidade.vue?vue&type=script&lang=js"
import style0 from "./BaseCardTotalizadorRastreabilidade.vue?vue&type=style&index=0&id=79710f90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79710f90",
  null
  
)

export default component.exports